import { createFileRoute, redirect } from '@tanstack/react-router'

type LegacyRenderDestination = {
  params: { projectId: string; workspaceSlug: string }
  search: Record<string, never>
  to: '/$workspaceSlug/renders/$projectId'
}

/** Retires the stale scene identifier while preserving its project destination. */
export const legacyRenderDestination = (params: {
  projectId: string
  sceneId: string
  workspaceSlug: string
}): LegacyRenderDestination => ({
  params: { projectId: params.projectId, workspaceSlug: params.workspaceSlug },
  search: {},
  to: '/$workspaceSlug/renders/$projectId',
})

/**
 * The scene page retired when the Mesa shipped: the project's Renders tab IS
 * the board now, with every room as a block. Legacy scene rows are no longer a
 * load-bearing source of room identity, so old links land on the project.
 */
export const Route = createFileRoute(
  '/_authenticated/$workspaceSlug/projects/$projectId_/renders/$sceneId'
)({
  beforeLoad: ({ params }) => {
    throw redirect(legacyRenderDestination(params))
  },
})
